"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = require("reselect");
var graph_ql_1 = require("../../types/graph-ql");
var ramda_1 = require("ramda");
var constants_1 = require("./constants");
var fastMemoize_1 = __importDefault(require("../../utils/fastMemoize"));
exports.getCollection = reselect_1.createSelector(function (state) { var _a; return (_a = state[constants_1.namespace].collectionsById) === null || _a === void 0 ? void 0 : _a.data; }, function (data) { return fastMemoize_1.default(function (collectionId) { return data[collectionId]; }); });
exports.getCollectionSelectedFilters = reselect_1.createSelector(function (state) { var _a; return (_a = state[constants_1.namespace].filtersById) === null || _a === void 0 ? void 0 : _a.data; }, function (data) { return fastMemoize_1.default(function (collectionId) { return data[collectionId]; }); });
exports.getGenreFilterOptions = reselect_1.createSelector(function (state) { var _a; return (_a = state[constants_1.namespace].collectionsById) === null || _a === void 0 ? void 0 : _a.data; }, function (data) {
    return fastMemoize_1.default(function (collectionId) {
        var _a;
        var options = [];
        var namedFilters = (_a = data[collectionId]) === null || _a === void 0 ? void 0 : _a.namedFilters;
        if (Array.isArray(namedFilters) && !ramda_1.isEmpty(namedFilters)) {
            options = [{ id: constants_1.COLLECTION_FILTER_VALUE_ALL, title: 'All' }].concat(namedFilters);
        }
        return {
            name: constants_1.COLLECTION_FILTER_GENRE,
            options: options,
        };
    });
});
exports.getSubscriptionFilterOptions = function (isTV) {
    if (isTV === void 0) { isTV = false; }
    return ({
        name: constants_1.COLLECTION_FILTER_SUBSCRIPTION,
        options: [
            { id: constants_1.COLLECTION_FILTER_VALUE_MYSUBSCRIPTION, title: 'My Subscription' },
            { id: constants_1.COLLECTION_FILTER_VALUE_ALL, title: isTV ? 'All' : 'All of Sky Go' },
        ],
    });
};
exports.getViewingContextFilterOptions = function (excludeDownloads) {
    if (excludeDownloads === void 0) { excludeDownloads = false; }
    var options = [
        { id: constants_1.COLLECTION_FILTER_VALUE_ONDEMAND, title: 'On Demand' },
        { id: constants_1.COLLECTION_FILTER_VALUE_UPCOMING_ON_TV, title: 'Upcoming On TV' },
    ];
    if (!excludeDownloads) {
        options.push({ id: constants_1.COLLECTION_FILTER_VALUE_DOWNLOADABLE, title: 'Downloadable' });
    }
    options.push({ id: constants_1.COLLECTION_FILTER_VALUE_ALL, title: 'All' });
    return {
        name: constants_1.COLLECTION_FILTER_VIEWINGCONTEXT,
        options: options,
    };
};
exports.getSortOptions = function () { return ({
    name: constants_1.COLLECTION_FILTER_SORT,
    options: Object.keys(graph_ql_1.CollectionOrder).map(function (key) {
        return {
            id: graph_ql_1.CollectionOrder[key],
            title: graph_ql_1.CollectionOrder[key] === graph_ql_1.CollectionOrder.Alphabetical ? 'A-Z' : key,
        };
    }),
}); };
exports.isLoading = reselect_1.createSelector(function (state) { return state[constants_1.namespace].collectionsById; }, function (contentRoot) { return contentRoot.isLoading; });
exports.error = reselect_1.createSelector(function (state) { return state[constants_1.namespace].collectionsById; }, function (contentRoot) { return contentRoot.error; });
exports.getBrowseCategories = reselect_1.createSelector(function (state) { return state[constants_1.namespace].browseCategories.data; }, function (data) { return data; });
exports.browseCategoriesIsLoading = reselect_1.createSelector(function (state) { return state[constants_1.namespace].browseCategories.isLoading; }, function (l) { return l; });
exports.browseCategoriesError = reselect_1.createSelector(function (state) { return state[constants_1.namespace].browseCategories.error; }, function (e) { return e; });
//# sourceMappingURL=selectors.js.map